import { Injectable, OnInit } from "@angular/core";
import { Vector2, Vector3 } from "three";
import { TouchPrimitive } from "../primitives/touch-primitive";
import { InputMiddleware } from "../primitives/i-input-middlware";
import { ThreeService } from "../../rendering/threejs/three.service";
import { Store } from "@ngrx/store";
import { cameraActions } from "src/app/state/camera/camera.actions";
import {
  selectCameraTarget,
  selectCameraZoomTarget,
} from "src/app/state/camera/camera.selector";
import { PointerTracker } from "../primitives/pointer-tracker";

@Injectable({
  providedIn: "root",
})
export class MapInputService extends TouchPrimitive implements InputMiddleware {
  maxZoom = 200;
  minZoom = 50000;
  cacheScrollValues: number[] = [];
  scrollCacheSize = 10

  scrollSessionStarted = false
  precisionScrollForSession = false

  zoomSteps = [
    100, 200, 300, 400, 500, 600, 800, 900, 1000, 1200, 1400, 1700, 1900, 2100,
    2300, 2500, 4000, 10000, 11000, 12000, 13000, 15000, 20000, 50000,
  ];
  zoomIndex = 3;
  zoomTarget = 0
  scrollTarget = 0
  cameraTarget$ = this.store.select(selectCameraTarget);
  lastMoveMomentum: Vector2 = new Vector2();
  lastEvent = new Date().getTime()

  currentScale = 0.5

  constructor(
    private threeService: ThreeService,
    private store: Store,
  ) {
    super();
    this.id = "MapInputMiddleware"
    this.cameraTarget$.subscribe((target) => { });
    this.store.select(selectCameraZoomTarget).subscribe((target) => {
      this.zoomTarget = target
      if (this.scrollTarget == 0) {
        this.scrollTarget = this.zoomTarget
      }
    })
  }

  isPricisionScroll(newAmount: number): boolean {
    if (new Date().getTime() - this.lastEvent > 2000) {
      this.precisionScrollForSession = false;
      if (Math.abs(newAmount) < 20) this.precisionScrollForSession = true;
      this.cacheScrollValues = []
    }
    this.lastEvent = new Date().getTime()
    this.cacheScrollValues.push(newAmount)
    if (this.cacheScrollValues.length > this.scrollCacheSize) this.cacheScrollValues.unshift()
    let testValue = this.cacheScrollValues[0]
    if (Math.abs(newAmount) * 1000000000 !== Math.abs(testValue) * 1000000000) this.precisionScrollForSession = true;
    return this.precisionScrollForSession
  }

  momentumTimer = null;

  momentum() {
    this.lastMoveMomentum.setLength(this.lastMoveMomentum.length() * 0.9);
    let camStartPos = this.threeService.camera.position.clone();
    const dist = this.threeService.pixelToWorldDistance(this.lastMoveMomentum);
    const move = new Vector3(-dist.x, dist.y, 0);
    this.store.dispatch(
      cameraActions.targetMoved({
        target: camStartPos.clone().add(move),
      }),
    );
    if (this.lastMoveMomentum.length() < 0.5) {
      clearInterval(this.momentumTimer);
    }
  }


  init() {
    console.log("MapInputMiddleware init onMove")
    this.onMove((amount: Vector2) => {
      let camStartPos = this.threeService.camera.position.clone();
      const dist = this.threeService.pixelToWorldDistance(
        amount.multiplyScalar(1),
      );
      const move = new Vector3(-dist.x, dist.y, 0);
      this.lastMoveMomentum.copy(amount);
      this.store.dispatch(
        cameraActions.targetMoved({
          target: camStartPos.clone().add(move),
        }),
      );
      return true;
    });
    this.onReleased((pointer: PointerTracker) => {
      if (this.lastMoveMomentum.length() > 0.5) {
        // this.momentumTimer = setInterval(this.momentum.bind(this), 15);
      }
      return true;
    });
    this.onScale((amount, event: WheelEvent | null) => {
      if (amount == 0) return false
      const diff = this.modify(amount)

      const moveX = 0.5 - (event.pageX / this.threeService.canvasWidth)
      const moveY = 0.5 - (event.pageY / this.threeService.canvasHeight)

      const newTargetX = this.threeService.camera.position.x + (moveX * diff * 0.035)
      const newTargetY = this.threeService.camera.position.y - (moveY * diff * 0.0225)

      this.zoomTarget += diff
      this.zoomTarget = Math.min(this.minZoom, Math.max(this.maxZoom, this.zoomTarget))
      this.store.dispatch(
          cameraActions.zoomChanged({
            absoluteZoom: this.zoomTarget
          }),
      );
      if (this.zoomTarget > this.maxZoom + 1) {
        this.store.dispatch(
            cameraActions.targetMoved({
              target: new Vector3(newTargetX, newTargetY, 0),
            }),
        );
      }
      return true;
    });
    return true;
  }

  modify(amount) {
    const bumpThreshold = 15
    if (amount < bumpThreshold && amount > -bumpThreshold) {
      amount *= 10
    }
    let dist = 6000 / Math.max(0.1, this.zoomTarget)
    if (amount < 0) {
      dist += dist
    }
    const final =amount * (10 /dist)
    // console.log(`Zoom: ${this.zoomTarget}, dist: ${dist}, amount: ${amount}, finalDelta: ${final}`)
    return final
  }

}
